import "./UpdateUsersCurrent.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import FormInput from "../../components/FormInput/FormInput";
import newRequest from "../../context/newRequest";

const UpdateUsersById = ({ title }) => {
    const [values, setValues] = useState({
        username: "",
        email: "",
        company_name: "",
        password: "",
        confirmPassword: "",
    });
    const [info, setInfo] = useState({})
    const { userId } = useParams();
    const user = localStorage.getItem("user");
    const { data, loading, error } = useFetch(`/users/_current`);
    const [sending, setSending] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        setInfo(data);
    }, [data]);




    console.info(values)



    const handleChange = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value });
    };


    const handleClick = async (e) => {
        e.preventDefault();
        try {
            setSending("On Submit")
            const newUsersUpdate = {
                ...values
            };

            const res= await newRequest.put(`/users`, newUsersUpdate, {
                // headers
                headers: {
                    'Authorization': `$Bearer ${user.token}`
                },
            });
            setSending("Sending...")
            if (res.status == 200) {
                navigate(`/users/_current`);
            }
            console.log(res.status)
        } catch (err) {
            setSending(err.response.data.errors)
            console.log(err);
        }
    };

    console.log(info)
    const inputs = [
        {
            id: "username",
            name: "username",
            type: "text",
            placeholder: "username",
            errorMessage:
                "Username should be 3-16 characters and shouldn't include any special character!",
            label: "Username",
            pattern: "^[A-Za-z0-9]{3,16}$",
            required: false,
        },
        {
            id: "email",
            name: "email",
            type: "email",
            placeholder: "email",
            errorMessage: "It should be a valid email address!",
            label: "Email",
            required: false,
        },
        {
            id: "company_name",
            name: "CompanyName",
            type: "text",
            placeholder: "company name",
            errorMessage:
                "Username should be 3-16 characters and shouldn't include any special character!",
            label: "Username",
            pattern: "^[A-Za-z0-9 ]{3,16}$",
            required: false,
        },
        {
            id: "password",
            name: "password",
            type: "password",
            placeholder: "Password",
            errorMessage:
                "Password should be 8-20 characters and include at least 1 uppercase letter, 2 numbers, and any other characters!",
            label: "Password",
            pattern: `^(?=.*[A-Z])(?=(?:.*[0-9]){2})[a-zA-Z0-9!@#$%^&*]{8,20}$`,
            required: false,
        },
        {
            id: "confirm_password",
            name: "confirmPassword",
            type: "password",
            placeholder: "Confirm Password",
            errorMessage: "Passwords don't match!",
            label: "Confirm Password",
            pattern: values.password,
            required: false,
        },
    ];

    return (
        <div className="new">
            <Sidebar />
            <div className="newContainer">
                <Navbar />
                <div className="top">
                    <h1>{title}</h1>
                </div>
                <div className="bottom">
                    <div className="right">
                        <div className="detailItem">
                            <span className="itemKey">Update Users Current</span>
                            <span className="itemValue">{userId}</span>
                        </div>
                        <form onSubmit={handleClick}>
                            {inputs.map((input) => (
                                <FormInput
                                    key={input.id}
                                    {...input}
                                    value={values[input.name]}
                                    onChange={handleChange}
                                />
                            ))}
                            <button>Submit</button>
                        </form>
                    </div>
                    {sending && <p className="error">{sending}</p>}
                </div>
            </div>
        </div>
    );
};

export default UpdateUsersById;
